const stopByteCondition = ({ connectedDevice, deviceVersion }) => {
    const PLAY_BYTES = [
        'P'.charCodeAt(0),
        'L'.charCodeAt(0),
        'A'.charCodeAt(0),
        'Y'.charCodeAt(0),
    ]

    try {
        const STOP_BYTES = [
            'S'.charCodeAt(0),
            'T'.charCodeAt(0),
            'O'.charCodeAt(0),
            'P'.charCodeAt(0),
        ]
        let sendStopBytes = PLAY_BYTES

        const stopConditions = [
            { device: 'Humanoid', minVersion: 4, startsWith: 2 },
            { device: 'Hexapod', minVersion: 3, startsWith: 2 },
            { device: 'Ace', minVersion: 7, startsWith: 1 },
            { device: 'Roboki', minVersion: 3 },
        ]

        if (
            stopConditions.some(
                ({ device, minVersion, startsWith }) =>
                    connectedDevice === device &&
                    (!startsWith ||
                        Number((deviceVersion?.split('.') || '0')[0]) >=
                            startsWith) &&
                    // (!startsWith || deviceVersion?.startsWith(startsWith)) &&
                    parseInt(deviceVersion?.slice(-1)) >= minVersion
            ) ||
            ['Klaw', 'Logiki', 'Toki', 'Poki', 'Atr', 'Moki'].includes(
                connectedDevice
            )
        ) {
            sendStopBytes = STOP_BYTES
        }

        return sendStopBytes
    } catch (e) {
        console.error(e)
        return PLAY_BYTES
    }
}

//ai not pracent for the following device and version
const isAi1NotPresent = ({ connectedDevice, deviceVersion }) => {
    const deviceList = [
        { device: 'Humanoid', startsWith: '1' },
        { device: 'Hexapod', startsWith: '1' },
        // { device: 'Hexapod', startsWith: '2' },
        { device: 'Ace', startsWith: '0' },
        // { device: 'Roboki', startsWith: '1' },
        { device: 'Moki', startsWith: '1' },
        { device: 'Toki', startsWith: '1' },
        { device: 'Poki', startsWith: '1' },
    ]

    if (
        deviceList.some(
            ({ device, startsWith }) =>
                connectedDevice === device &&
                (!startsWith || deviceVersion?.startsWith(startsWith))
        )
    ) {
        return true
    }

    return false
}

//check the Ai-1 is show for which device and which version
const isAi1ShowCondition = ({ connectedDevice, deviceVersion }) => {
    try {
        // return deviceConditions[connectedDevice]?.(deviceVersion) ?? false
        const stopConditions = [
            { device: 'Humanoid', minVersion: 5, startsWith: 2 },
            { device: 'Hexapod', minVersion: 3, startsWith: 2 },
            { device: 'Ace', minVersion: 8, startsWith: 1 },
            { device: 'Roboki', minVersion: 3 },
        ]

        if (
            stopConditions.some(
                ({ device, minVersion, startsWith }) =>
                    connectedDevice === device &&
                    (!startsWith ||
                        Number((deviceVersion?.split('.') || '0')[0]) >=
                            startsWith) &&
                    // (!startsWith || deviceVersion?.startsWith(startsWith)) &&
                    parseInt((deviceVersion?.split('.') || '0')[2]) >=
                        minVersion
            ) ||
            ['Klaw', 'Atr'].includes(connectedDevice)
        ) {
            return true
        }

        return false
    } catch (e) {
        console.error(e)
        return false
    }
}

//delete the aiTranlist data from the localstorage if connectDevice change.
// const ifAiTranDataDelete = (device) => {
//     console.log(device)
//     try {
//         const aiTrainList = JSON.parse(localStorage.getItem('aiTrainList'))
//         // const connectedDevice = sessionStorage.getItem('connectedDevice')
//         if (device !== aiTrainList?.connectedDevice) {
//             localStorage.removeItem('aiTrainList')
//         }
//     } catch (e) {
//         console.error(e)
//         localStorage.removeItem('aiTrainList')
//     }
// }

const getDeviceName = (connectedDevice) => {
    switch (connectedDevice) {
        case 'Ace':
            return 'PeeCee'
        case 'Humanoid':
            return 'Zing'
        case 'Hexapod':
            return 'Crawl-e'
        case 'Klaw':
            return 'Klaw-b'
        default:
            return connectedDevice
    }
}

const getDeviceNameWithVersion = (connectedDevice, deviceVersion = '1.0.0') => {
    const versionLabel = `(v${deviceVersion.split('.').slice(0, 2).join('.')})`

    const deviceMap = {
        Humanoid: `Zing ${versionLabel}`,
        Ace: `PeeCee ${versionLabel}`,
        Hexapod: `Crawl-e ${versionLabel}`,
        Klaw: `Klaw-b ${versionLabel}`,
    }

    const deviceEntry = deviceMap[connectedDevice]

    if (!connectedDevice) return `PeeCee ${versionLabel}`

    if (deviceEntry) return deviceEntry

    return `${connectedDevice} ${versionLabel}`
}

//check the if connected device is Atr test the pwm output  is share or not
const checkIsPwmOutput = (component) => {
    return [
        'led_1c',
        'led',
        'dc_motor',
        'mini_geared_motor',
        'servo_motor',
        'servo_motor_270',
        'servo_motor_360',
    ].includes(component)
}

export {
    stopByteCondition,
    isAi1ShowCondition,
    // ifAiTranDataDelete,
    getDeviceName,
    isAi1NotPresent,
    getDeviceNameWithVersion,
    checkIsPwmOutput,
}
